import React from "react";
import { useDispatch, useSelector } from "react-redux";
import jsYaml from "js-yaml";
import { GetRulesAndFilters } from "@emisgroup/cohort-builder";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { OutputConfigSlice } from "../../redux";
import { APP_KEY, ETHNIC_FEATURE, GENDER_FEATURE } from "../Constant";
import { BandsTypes } from "../Types";
import { BandingGenderFormView } from "./BandingGenderForm.view";
import { GenderOrEthnicBand } from "./Helper";

interface BandingGenderFormProps {
  /**
   * Onchange for Band name
   */
  onChange?: (name: string) => void;
  /**
   * Entered banding name in textfield
   */
  bandingName: string;
}

/**
 * Responsible for gender banding popup logic
 * @returns Gender banding popup logic
 */
export const BandingGenderForm: React.FC<BandingGenderFormProps> = (props: BandingGenderFormProps) => {
  const dispatch = useDispatch();
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const selectedBandingType = outputConfig.selectedBandingDetails.bandType;
  const GenderOrEthnicBandType = selectedBandingType === BandsTypes.GENDER ? GENDER_FEATURE : ETHNIC_FEATURE;
  const currentValues = outputConfig.selectedGenders;
  const selectedBandingDefinition = outputConfig.selectedBandingDetails.definition;
  GetRulesAndFilters(APP_KEY);
  const genderDatasource = GenderOrEthnicBand(GenderOrEthnicBandType);

  /**
   * Responsible for rendering the logical value from definition
   */
  React.useEffect(() => {
    let runParam;
    if(selectedBandingDefinition) {
      const parseGenderDefinition: any = jsYaml.load(selectedBandingDefinition);
      runParam = parseGenderDefinition?.run?.[0];
    }
    const definition = runParam || selectedBandingDefinition;
    const parsedDefinition = definition?.split("Sex:")?.[1]?.split(":");
    if(parsedDefinition && parsedDefinition?.length > 0) {
      parsedDefinition.forEach((item: string) => {
        dispatch(OutputConfigSlice.actions.updateSelectedGenders({
          value: item,
          checked: true
        }));
      });
    }
  }, [selectedBandingDefinition]);

  /**
   * Handler for gender and ethinicity onchange
   * @param val updated value
   */
  /* Const handleOnChange = (val: string) => (ev: React.SyntheticEvent<any, Event>): void => {
    const check = ev.currentTarget.checked; */
  const handleOnChange = (val: string) => (isChecked: boolean): void => {
    dispatch(OutputConfigSlice.actions.updateSelectedGenders({ value: val, checked: isChecked }));
  };

  /**
   * Handler for gender and ethinicity onchange
   * @param val updated value
   */
  const handleNameChange = (e: React.SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    if (props.onChange){
      props.onChange(e.target["value"]);
    }
  };

  return (
    <BandingGenderFormView
      type={GenderOrEthnicBandType}
      onChange={handleOnChange}
      currentValues={currentValues}
      dataSource={genderDatasource}
      genderBandName={props.bandingName}
      onNameChange={handleNameChange}
    />
  );
};
